<div fxLayout="column" fxFill fxLayoutAlign="center top">
  <app-header fxFlex></app-header>
  <div class="main-content-container" fxFlex="grow">
    <router-outlet></router-outlet>
  </div>
</div>
